/**
 * Русский словарь — эталон набора ключей: остальные языки обязаны покрыть его целиком.
 * Ключи плоские, `<область>.<что>`. Подстановка — `{name}`. Строка с формой числа —
 * ключи `<область>.<что>.one` / `.few` / `.many` / `.other` (у `uz` и `en` — `.one` и
 * `.other`), переводится `tn(ключ, число)`; `.other` у русского — дроби.
 */
export const ru = {
  'common.currency': 'сум',
  'common.amount': '{amount} сум',
  'common.toCatalog': 'Вернуться в каталог',
  'common.support': 'Написать в поддержку',
  'common.retry': 'Повторить',
  'common.cancel': 'Отмена',
  'purchase.step': 'Шаг {step} из 3 · {name}',
  'purchase.stepAmount': 'Номинал',
  'purchase.stepGreeting': 'Получатель и поздравление',
  'purchase.stepPay': 'Оплата',
  'howTo.title': 'Как отправить подарок',
  'howTo.sub': 'Инструкция в сторис · 6 шагов',
  'howTo.tipSub': 'Покажем в сторис за 6 шагов',
  'howTo.tipHide': 'Скрыть подсказку',

  'catalog.search': 'Поиск партнёра',
  'catalog.searchClear': 'Очистить поиск',
  'catalog.allCategories': 'Все',
  'catalog.categories': 'Категории',
  'catalog.priceFrom': 'от {amount}',
  'catalog.priceSingle': '{amount} сум',
  'catalog.emptySearchTitle': 'Ничего не нашлось',
  'catalog.emptySearchText': 'Попробуйте другое название или категорию.',
  'catalog.emptyCategoryTitle': 'В этой категории пока нет партнёров',
  'catalog.emptyCategoryText': 'Выберите другую категорию или загляните позже.',
  'catalog.emptyTitle': 'Партнёров пока нет',
  'catalog.emptyText': 'Скоро здесь появятся подарки.',
  'catalog.resetFilters': 'Показать всех партнёров',
  'catalog.loadErrorTitle': 'Не удалось загрузить партнёров',
  'catalog.loadErrorOffline': 'Проверьте подключение к интернету и попробуйте ещё раз.',
  'catalog.loadErrorText': 'Попробуйте ещё раз через минуту.',
  'catalog.loadMoreError': 'Не удалось загрузить ещё',

  /* Категории — ключи `BrandCategory` бэкенда; названия живут только здесь. */
  'category.food': 'Еда',
  'category.beauty': 'Красота',
  'category.sport': 'Спорт',
  'category.clothing': 'Одежда',
  'category.electronics': 'Электроника',
  'category.entertainment': 'Развлечения',
  'category.services': 'Услуги',
  'category.kids': 'Детям',

  'partner.pickAmount': 'Выберите номинал',
  'partner.amountTitle': 'Номинал',
  'partner.next': 'Далее · {amount} сум',
  'partner.note': 'Ваучер без срока действия и придёт сразу после оплаты — вы отправите его в чат сами.',
  'partner.where': 'Где принимают',
  'partner.unavailableTitle': 'Подарки временно недоступны',
  'partner.unavailableText': 'Сейчас этого партнёра нельзя подарить. Загляните позже или выберите другого.',
  'partner.notFoundTitle': 'Партнёр не найден',
  'partner.notFoundText': 'Ссылка устарела или партнёр больше не работает с нами.',

  'checkout.change': 'Изменить',
  'checkout.recipientName': 'Имя получателя',
  'checkout.recipientPlaceholder': 'Например, Малика',
  'checkout.recipientNote': 'Ваше имя Telegram подставит из профиля автоматически.',
  'checkout.message': 'Поздравление',
  'checkout.messagePlaceholder': 'Пара тёплых слов — их увидит получатель',
  'checkout.messageHint': 'Появится после анимации открытия подарка.',
  'checkout.ideas': 'Готовые поздравления',
  'checkout.idea1': 'С днём рождения!',
  'checkout.idea1Text': 'С днём рождения! Пусть этот год будет щедрым на радость и тёплые встречи.',
  'checkout.idea1Named': '{name}, с днём рождения! Пусть этот год будет щедрым на радость и тёплые встречи.',
  'checkout.idea2': 'Поздравляю!',
  'checkout.idea2Text': 'Поздравляю! Ты это заслужил(а) — пусть всё получается.',
  'checkout.idea2Named': '{name}, поздравляю! Ты это заслужил(а) — пусть всё получается.',
  'checkout.idea3': 'Спасибо тебе',
  'checkout.idea3Text': 'Спасибо тебе за всё — это маленький знак большой благодарности.',
  'checkout.idea3Named': '{name}, спасибо тебе за всё — это маленький знак большой благодарности.',
  'checkout.idea4': 'С праздником!',
  'checkout.idea4Text': 'С праздником! Пусть будет много тепла и улыбок.',
  'checkout.idea4Named': '{name}, с праздником! Пусть будет много тепла и улыбок.',
  'checkout.idea5': 'Просто так',
  'checkout.idea5Text': 'Просто так — чтобы порадовать тебя сегодня.',
  'checkout.idea5Named': '{name}, это просто так — чтобы порадовать тебя сегодня.',
  'checkout.presetReplace': 'Заменить ваш текст на «{text}»?',
  'checkout.presetReplaceOk': 'Заменить',
  'checkout.note': 'Способ оплаты выберете на следующем шаге.',
  'checkout.toPay': 'Перейти к оплате',
  'checkout.pendingTitle': 'Этот подарок ждёт оплаты',
  'checkout.pendingText': 'Мы ещё не получили подтверждение от платёжной системы.',
  'checkout.pendingAction': 'Проверить оплату',
  'checkout.paidTitle': 'Этот подарок уже оплачен',
  'checkout.paidText': 'Повторно платить не нужно — осталось отправить его в чат.',
  'checkout.paidAction': 'Открыть подарок',
  'checkout.unavailableTitle': 'Подарок больше недоступен',
  'checkout.unavailableText': 'Этот номинал сейчас не продаётся. Выберите другой подарок в каталоге.',

  'pay.method': 'Способ оплаты',
  'pay.methodClick': 'Карта UZCARD или Humo в окне Click',
  'pay.methodPayme': 'Карта или баланс Payme',
  'pay.methodFoot': 'Оплата проходит на защищённой странице платёжной системы. Когда банк её подтвердит, экран обновится сам.',
  'pay.payAmount': 'Оплатить · {amount} сум',
  'pay.opening': 'Открываем платёжную систему…',
  'pay.openingHint': 'Не закрывайте окно, это займёт пару секунд',
  'pay.retry': 'Повторить оплату',
  'pay.leaveConfirm': 'Оплата ещё идёт. Если уйти с экрана, она не прервётся: когда банк её подтвердит, подарок будет ждать отправки.',
  'pay.leave': 'Уйти',
  'pay.stay': 'Остаться',
  'pay.errorDailyCount': 'Сегодня вы уже купили {limit} подарков — это дневной лимит. Попробуйте завтра.',
  'pay.errorDailyAmount': 'С этим подарком покупки за сегодня превысят {limit} сум — это дневной лимит. Выберите номинал поменьше или попробуйте завтра.',
  'pay.errorProviderDown': '{provider} сейчас не отвечает. Выберите другой способ оплаты.',
  'pay.errorInProgress': 'Оплата через {provider} ещё не завершена. Дождитесь её результата, прежде чем платить другим способом.',
  'pay.errorInProgressAction': 'Вернуться к оплате',
  'pay.errorNetwork': 'Нет соединения. Проверьте интернет и попробуйте ещё раз.',
  'pay.errorUnknown': 'Не получилось начать оплату. Попробуйте ещё раз.',
  'pay.giftKind': 'Подарочный сертификат',
  'pay.price': 'Стоимость',
  'pay.total': 'К оплате',

  'payWait.title': 'Ожидаем оплату',
  'payWait.text': 'Завершите оплату на странице платёжной системы — экран обновится сам, как только банк её подтвердит.',
  'payWait.checkingTitle': 'Проверяем оплату',
  'payWait.checkingText': 'Банк ещё не прислал подтверждение. Обычно это занимает пару минут — экран обновится сам.',
  'payWait.stalledTitle': 'Оплата ещё не подтверждена',
  'payWait.stalledText': 'Подтверждение задерживается. Проверьте ещё раз чуть позже — оплата не потеряется.',
  'payWait.checkAgain': 'Проверить ещё раз',
  'payWait.reopen': 'Открыть страницу оплаты',
  'payWait.timeLeft': 'Счёт действует ещё {time}',
  'payWait.offline': 'Нет соединения — проверим, как только появится сеть.',

  'paySuccess.title': 'Оплата прошла',
  'paySuccess.text': 'Подарок готов. Нажмите «Отправить подарок» и выберите чат с получателем.',
  'paySuccess.send': 'Отправить подарок',
  'paySuccess.recipient': 'Получатель',
  'paySuccess.order': 'Номер заказа',
  'paySuccess.time': 'Время',
  'paySuccess.sendFallback': 'Откройте чат с получателем, напишите {bot} и выберите подарок.',
  'paySuccess.sendFallbackNoBot': 'Откройте чат с получателем, напишите имя нашего бота через @ и выберите подарок.',
  'stories.step': 'Шаг {step} из 6',
  'stories.step1': 'Выберите сертификат',
  'stories.step2': 'Укажите сумму и поздравление',
  'stories.step3': 'Оплатите',
  'stories.step4': 'Нажмите «Отправить подарок» и выберите чат',
  'stories.step5': 'Выберите подарок в списке',
  'stories.step6': 'Отправьте',
  'stories.manualHint': 'или напишите в чате {bot} и выберите подарок',
  'stories.manualHintNoBot': 'или напишите в чате имя нашего бота через @ и выберите подарок',
  'stories.gotIt': 'Понятно',
  'stories.close': 'Закрыть',
  'stories.prev': 'Предыдущий шаг',
  'stories.next': 'Следующий шаг',

  'payCancel.title': 'Оплата отменена',
  'payCancel.text': 'Деньги не списаны. Черновик подарка сохранён — можно вернуться к оплате.',

  'payFail.title': 'Платёж не прошёл',
  'payFail.notCharged': 'Деньги не списаны.',
  'payFail.otherMethod': 'Другой способ оплаты',
  /* Причины отказа — по `PaymentFailureCode` бэкенда. Сырой код агрегатора сюда не попадает. */
  'payFail.insufficientFunds': 'Банк отклонил операцию: недостаточно средств на карте.',
  'payFail.cardBlocked': 'Банк отклонил операцию: карта заблокирована.',
  'payFail.cardExpired': 'Банк отклонил операцию: истёк срок действия карты.',
  'payFail.limitExceeded': 'Банк отклонил операцию: превышен лимит по карте.',
  'payFail.declinedByBank': 'Банк отклонил операцию и не назвал причину.',
  'payFail.cancelledByUser': 'Оплата отменена на странице платёжной системы.',
  'payFail.timeout': 'Время на оплату у платёжной системы истекло.',
  'payFail.providerError': 'Сбой на стороне платёжной системы.',
  'payFail.unknown': 'Платёжная система отклонила платёж и не назвала причину.',

  'payExpired.title': 'Время на оплату вышло',
  'payExpired.text': 'Деньги не списаны. Оформите подарок заново — поздравление сохранено.',
  'payExpired.restart': 'Оформить заново',

  'payResult.notFoundTitle': 'Заказ не найден',
  'payResult.notFoundText': 'Ссылка устарела или заказ оформлен с другого аккаунта.',

  /* Экран 10 — распаковка. Заголовок — как в карточке подарка в чате (бэкенд, `bot-templates.ts`). */
  'unwrap.from': 'Вам подарок от {name}',
  'unwrap.fromAnonymous': 'Вам анонимный подарок',
  'unwrap.tapToOpen': 'Нажмите, чтобы открыть',
  'unwrap.opening': 'Открываем подарок…',
  'unwrap.failedOffline': 'Нет соединения. Проверьте интернет — подарок откроется, как только связь вернётся.',
  'unwrap.failed': 'Не получилось открыть подарок. Попробуйте ещё раз через минуту.',

  /* Экран 09 — сцена GiftBox и карточка-сюрприз. Карточка без ответа бэкенда — без партнёра и суммы. */
  'unwrap.open': 'Открыть подарок',
  'unwrap.what': 'Что же внутри?',
  'unwrap.tease1': 'Может, сертификат в любимый магазин?',
  'unwrap.tease2': 'А может — тёплые слова от {name}?',
  'unwrap.tease2Anonymous': 'А может — тёплые слова?',
  'unwrap.tease3': 'Откройте и узнайте первыми!',
  'unwrap.reveal': 'Сертификат для вас!',
  'unwrap.revealSub': 'Сейчас покажем поздравление',
  'reveal.genericTitle': 'Подарок',
  'reveal.genericAmount': 'Сертификат',
  'reveal.genericUnit': 'для вас',

  /* Исходы открытия подарка (БП-7). Экран 12 не раскрывает о подарке ничего. */
  'gift.takenTitle': 'Ой! Подарок не найден',
  'gift.takenText': 'Его уже открыл кто-то другой или он больше недоступен. Пересланные подарки не работают.',
  'gift.giveOwn': 'Подарить самому',
  'gift.notSentTitle': 'Этот подарок ещё не вручён',
  'gift.notSentText': 'Отправитель ещё не отправил его в чат или отозвал. Попросите прислать подарок заново.',
  'gift.goneTitle': 'Подарок больше недоступен',
  'gift.goneText': 'Подарок отменён, ваучер больше не действует. Если это ошибка — напишите в поддержку.',
  'gift.blockedTitle': 'Подарок временно недоступен',
  'gift.blockedText': 'Мы проверяем этот подарок. Напишите в поддержку — поможем разобраться.',
  'gift.ownBlocked': 'Подарок временно недоступен: мы его проверяем.',
  'gift.giveMore': 'Подарить ещё',

  /* Экраны 10, 13, 14 — «Принять или отказаться» (БП-7, BE-51). Глагол отправителя — в настоящем времени: пол неизвестен. */
  'gift.decisionClosedTitle': 'Подарок вернулся к отправителю',
  'gift.decisionClosedText': 'Решение по нему уже не принять: время на него вышло или вы отказались от подарка на другом устройстве.',
  'decision.anonymous': 'Анонимный отправитель',
  'decision.sends': 'отправляет вам подарок',
  'decision.sentAt': '{date}, {time}',
  'decision.kind': 'Подарочный сертификат',
  'decision.noExpiry': 'Без срока действия',
  'decision.where': 'Где принимают',
  'decision.acceptHint': 'Примите подарок — и получите QR-код для оплаты на кассе.',
  'decision.deadline': 'Если не решите до {date}, {time}, подарок вернётся отправителю.',
  'decision.accept': 'Принять подарок',
  'decision.decline': 'Отказаться от подарка',
  'decision.declineConfirm': 'Подарок вернётся отправителю. Отказаться?',
  'decision.declineYes': 'Отказаться',
  'decision.declineNo': 'Оставить подарок',
  'decision.offline': 'Нет соединения. Проверьте интернет и нажмите ещё раз.',
  'decision.failed': 'Не получилось. Попробуйте ещё раз через минуту.',
  'decision.declinedTitle': 'Подарок возвращён отправителю',
  'decision.declinedText': 'Мы сообщим отправителю — подарок снова у него, и его можно подарить кому-то ещё.',
  'decision.toCatalog': 'В каталог',
  'voucher.accepted': 'Подарок принят',

  /*
   * Экран 11 — ваучер. Срок — «без срока действия» (Р-5), погашение — только
   * целиком (Р-4). Шаги инструкции — не длиннее двух строк на всех языках.
   */
  'voucher.from': '— {name}',
  'voucher.fromOnly': 'Подарок от {name}',
  'voucher.qrLabel': 'QR-код ваучера для кассы',
  'voucher.copy': 'Скопировать',
  'voucher.usedTitle': 'Ваучер уже использован',
  'voucher.numberLabel': 'Номер ваучера',
  'voucher.howTo': 'Как использовать',
  'voucher.howStep1': 'Нажмите «Показать кассиру» — или продиктуйте номер ваучера',
  'voucher.howStep2': 'Кассир отсканирует код и подтвердит сумму',
  'voucher.howStep3': 'Ваучер списывается целиком за одну покупку',
  'voucher.partnerNote': 'От партнёра',
  'voucher.terms': 'Условия использования',
  'voucher.where': 'Где принимают',
  'voucher.noLocations': 'Сейчас нет открытых точек. Напишите в поддержку — подскажем, где принять ваучер.',
  'voucher.offline': 'Нет соединения. Ваучер показан из памяти телефона — QR-код действует.',
  'voucher.offlineLoading': 'Нет соединения. Ваучер появится, как только связь вернётся.',
  'voucher.doneTitle': 'Ваучер погашен',
  'voucher.undoText': 'Если покупка не состоялась, попросите кассира отменить погашение — ваучер снова станет действующим. Позже — только через поддержку.',
  'voucher.cancelledTitle': 'Погашение отменено',
  'voucher.cancelledText': 'Ваучер снова действует. Если покупка продолжается, покажите QR-код кассиру ещё раз.',

  /* Экраны 15–19: ваучер, QR для кассира, погашение и его отмена */
  'voucher.codeHint': 'Если QR-код не считывается, кассир введёт этот номер вручную',
  'voucher.qrHint': 'Кассир сканирует QR-код или вводит номер ваучера вручную',
  'voucher.codeCopied': 'Код скопирован',
  'voucher.nominal': 'Номинал',
  'voucher.showButton': 'Показать кассиру',
  'voucher.showButtonLabel': 'Показать QR-код кассиру',
  'voucher.showAgain': 'Показать QR снова',
  'voucher.close': 'Закрыть',
  'voucher.doneText': 'Ваучер на {amount} сум использован.',
  'voucher.time': 'Время',
  'voucher.undoTitle': 'Можно отменить до {time}',
  'voucher.done': 'Готово',
  'voucher.usedAt': 'Использован {date}',
  'qr.done': 'Готово',
  'qr.caption': '{brand} · {amount} сум',
  'qr.waiting': 'Ждём сканирования кассиром…',

  /* Точки продаж — блок «Где использовать». Время — местное, по Ташкенту. */
  'location.closedToday': 'Сегодня выходной',

  /* Экраны 11–12: «Где принимают», выбор навигатора */
  'location.open': 'Открыто',
  'location.until': 'до {time}',
  'location.closed': 'Закрыто',
  'location.opensAt': 'откроется в {time}',
  'location.meters': '{value} м',
  'location.kilometers': '{value} км',
  'locations.search': 'Поиск по адресу или району',
  'locations.points.one': '{count} точка',
  'locations.points.few': '{count} точки',
  'locations.points.many': '{count} точек',
  'locations.points.other': '{count} точки',
  'locations.countNearest': '{points} · ближайшие сверху',
  'locations.found': 'Найдено: {count}',
  'locations.hint': 'Нажмите на точку, чтобы построить маршрут в навигаторе.',
  'locations.showNearest': 'Показать ближайшие',
  'locations.emptyTitle': 'Точек пока нет',
  'locations.notFound': 'Ничего не найдено',
  'locations.notFoundSub': 'Попробуйте другой адрес или район',
  'navigator.yandexNavi': 'Яндекс Навигатор',
  'navigator.yandexMaps': 'Яндекс Карты',
  'navigator.googleMaps': 'Google Maps',
  'navigator.2gis': '2ГИС',
  'navigator.default': 'по умолчанию',
  'navigator.call': 'Позвонить · {phone}',
  'navigator.copyAddress': 'Скопировать адрес',
  'navigator.addressCopied': 'Адрес скопирован',

  'notFound.title': 'Страница не найдена',
  'notFound.text': 'Ссылка устарела или подарок был удалён.',

  'reopenApp.title': 'Откройте приложение заново',
  'reopenApp.text': 'Приложение было открыто слишком долго. Закройте его и запустите снова.',
  'reopenApp.draftKept': 'Имя получателя и поздравление сохранятся — они подставятся, когда вы снова оформите подарок.',
  'reopenApp.close': 'Закрыть приложение',

  'accountBlocked.title': 'Аккаунт заблокирован',
  'accountBlocked.text': 'Приложение сейчас недоступно для этого аккаунта, но купленные и полученные ваучеры действуют. Напишите в поддержку и приложите код ниже — поможем их предъявить.',

  'appError.title': 'Что-то сломалось',
  'appError.text': 'Мы уже получили отчёт об ошибке. Обновите экран — черновик подарка сохранён.',
  'appError.reload': 'Обновить экран',

  'netError.title': 'Нет соединения',
  'netError.text': 'Проверьте интернет и повторите — данные подтянутся автоматически.',

  /* Настройки. Названия языков сюда не входят: они на своём языке, см. `LANGUAGE_NAME`. */
  'settings.language': 'Язык',
  'settings.theme': 'Тема',
  'settings.themeSystem': 'Как в Telegram',
  'settings.themeLight': 'Светлая',
  'settings.themeDark': 'Тёмная',

  /* Итерация 4: онбординг, профиль, язык, оформление, поддержка. */
  'onboarding.giftTitle': 'Подарки, которые запоминаются',
  'onboarding.giftLead': 'Сертификаты партнёров — всё внутри Telegram, без приложений и регистрации.',
  'onboarding.giftPoint1': 'Подарок открывается красиво — как настоящая коробка',
  'onboarding.giftPoint2': 'Сертификаты магазинов, кафе и сервисов',
  'onboarding.payTitle': 'Оплата за пару секунд',
  'onboarding.payLead': 'Click и Payme в защищённом окне провайдера — данные карты к нам не попадают.',
  'onboarding.payPoint1': 'Карты UZCARD и Humo — через Click и Payme',
  'onboarding.payPoint2': 'История покупок со статусами',
  'onboarding.sendTitle': 'Подарок готов заранее',
  'onboarding.sendLead': 'После оплаты нажмите «Отправить подарок» и выберите чат — подарок уйдёт вместе с поздравлением.',
  'onboarding.sendPoint1': 'Поздравление внутри подарка',
  'onboarding.sendPoint2': 'Получатель покажет QR-код на кассе',
  'onboarding.next': 'Далее',
  'onboarding.start': 'Начать',
  'onboarding.skip': 'Пропустить',
  'onboarding.progress': 'Шаг {step} из {total}',

  'profile.title': 'Профиль',
  'profile.statReceived': 'Получено подарков',
  'profile.statGiven': 'Подарено',
  'profile.language': 'Язык',
  'profile.support': 'Поддержка',

  'appearance.title': 'Оформление',
  'appearance.footer': '«Как в Telegram» — тема переключается вместе с клиентом.',

  'language.title': 'Язык',
  'language.footer': 'Язык применяется сразу ко всем экранам. По умолчанию берётся из профиля Telegram. На этом языке вам будет писать и бот.',
  'language.uz': 'Узбекский',
  'language.ru': 'Русский',
  'language.en': 'Английский',

  'support.topic': 'Тема обращения',
  'support.message': 'Сообщение',
  'support.messageHint': 'Опишите, что случилось. Ответ поддержки появится в «Моих обращениях».',
  'support.messagePlaceholder': 'Например: кассир не смог отсканировать QR-код',
  'support.send': 'Отправить',
  'support.sendDisabled': 'Напишите хотя бы пару слов',
  'support.sendOffline': 'Нет соединения — сообщение не отправлено. Текст сохранён, повторите.',
  'support.sendFailed': 'Не удалось отправить. Попробуйте ещё раз.',
  'support.gift': 'Подарок',
  'support.giftHint': 'Подарок приложим к обращению сами — номер искать не нужно.',
  'support.myTickets': 'Мои обращения',
  'support.sent': 'Обращение {number} отправлено',

  'ticket.kindPayment': 'Проблема с оплатой',
  'ticket.kindVoucher': 'Ваучер не приняли',
  'ticket.kindRefund': 'Возврат денег',
  'ticket.kindGeneral': 'Другой вопрос',
  'ticket.statusOpen': 'Открыто',
  'ticket.statusInProgress': 'В работе',
  'ticket.statusWaiting': 'Ждём ответа',
  'ticket.statusResolved': 'Решено',
  'ticket.statusClosed': 'Закрыто',
  'ticket.status': 'Статус',
  'ticket.reply': 'Ответ',
  'ticket.replyPlaceholder': 'Напишите ответ',
  'ticket.replyDisabled': 'Напишите ответ',
  'ticket.replySent': 'Ответ отправлен',
  'ticket.closedHint': 'Обращение закрыто. Если вопрос остался — создайте новое.',
  'ticket.newTicket': 'Новое обращение',
  'ticket.notFoundTitle': 'Обращение не найдено',
  'ticket.notFoundText': 'Возможно, ссылка устарела. Создайте новое обращение — поможем.',
  'ticket.emptyTitle': 'Обращений пока нет',
  'ticket.emptySub': 'Здесь появятся ваши обращения и ответы поддержки.',
  'ticket.authorYou': 'Вы',
  'ticket.authorSupport': 'Поддержка',
  /* Экраны 21 и 30 — «Мои подарки» и «История заказов» (итерация 5, BE-54, BE-55). Статуса «Истёк» нет — Р-5. */
  'profile.myGifts': 'Мои подарки',
  'profile.history': 'История заказов',
  'myGifts.tabs': 'Какие подарки показать',
  'myGifts.received': 'Полученные',
  'myGifts.give': 'Подарить',
  'myGifts.receivedFooter': 'Подарки, которые вы открыли. Код и QR — внутри, после «Принять подарок».',
  'myGifts.giveFooter': 'Оплаченные подарки ждут отправки: нажмите «Отправить подарок» и выберите чат. Отправленный, но ещё не открытый подарок можно отозвать.',
  'myGifts.emptyReceivedTitle': 'Подарков пока нет',
  'myGifts.emptyReceivedText': 'Полученные подарки появятся здесь, как только вы откроете коробку.',
  'myGifts.emptyGiveTitle': 'Нечего подарить',
  'myGifts.emptyGiveText': 'Купите сертификат в каталоге — он появится здесь и будет ждать отправки.',
  'giftList.title': '{brand} · {amount}',
  'giftList.from': 'от {name}',
  'giftList.fromAnonymous': 'анонимно',
  'giftList.loadErrorTitle': 'Не удалось загрузить подарки',
  'giftStatus.ready': 'Готов к отправке',
  'giftStatus.sent': 'Отправлен',
  'giftStatus.opened': 'Открыт, ждёт ответа',
  'giftStatus.accepted': 'Принят',
  'giftStatus.redeemed': 'Погашен',
  'giftStatus.blocked': 'На проверке',
  'giftStatus.refunded': 'Деньги возвращены',
  'giftStatus.awaitingDecision': 'Ждёт решения',
  'giftStatus.active': 'Действует',
  'giftStatus.used': 'Использован',
  'giftStatus.unavailable': 'Недоступен',
  'history.filters': 'Статус подарков',
  'history.all': 'Все',
  'history.active': 'Активные',
  'history.redeemed': 'Погашенные',
  'history.refunded': 'Возвраты',
  'history.footer': 'Все подарки, которые вы купили. Код ваучера видит только получатель.',
  'history.emptyTitle': 'Покупок пока нет',
  'history.emptyText': 'Купленные сертификаты появятся здесь.',
  'history.emptyFilterTitle': 'Здесь пока пусто',
  'history.emptyFilterText': 'Подарков с таким статусом нет.',
  'paySuccess.later': 'Отправлю позже — подарок останется в «Моих подарках»',

  /* Карточка своего подарка у дарителя (без макета): статус, путь, отзыв и возврат денег (БП-6, БП-10). */
  'ownGift.status': 'Статус',
  'ownGift.number': 'Номер подарка',
  'ownGift.orderNumber': 'Номер заказа',
  'ownGift.timeline': 'История подарка',
  'ownGift.paidAt': 'Оплачен',
  'ownGift.sentAt': 'Отправлен в чат',
  'ownGift.openedAt': 'Открыт',
  'ownGift.claimedAt': 'Принят',
  'ownGift.redeemedAt': 'Погашен',
  'ownGift.refundedAt': 'Деньги возвращены',
  'ownGift.dateTime': '{date}, {time}',
  'ownGift.greeting': 'Поздравление',
  'ownGift.anonymous': 'Без подписи — подарок анонимный',
  'ownGift.stateReady': 'Подарок ещё не отправлен. Нажмите «Отправить подарок», выберите чат, а в списке — этот подарок.',
  'ownGift.stateSent': 'Подарок в чате. Его получит тот, кто первым нажмёт «Открыть подарок».',
  'ownGift.stateOpened': 'Получатель открыл коробку и решает, принять ли подарок.',
  'ownGift.stateAccepted': 'Получатель принял подарок. Код ваучера видит только он.',
  'ownGift.stateRedeemed': 'Подарок использовали в {place}.',
  'ownGift.stateRedeemedNoPlace': 'Подарок использовали.',
  'ownGift.stateRefunded': 'Деньги за подарок возвращены — они придут на карту в течение 1–7 дней.',
  'ownGift.decisionTitle': 'Ответ — до {date}, {time}',
  'ownGift.decisionText': 'Не ответит — подарок вернётся к вам. Отозвать открытый подарок нельзя.',
  'ownGift.revoke': 'Отозвать подарок',
  'ownGift.revokeFooter': 'Карточка в чате перестанет открываться, а подарок вернётся к вам — его можно будет отправить снова.',
  'ownGift.revokeConfirm': 'Отозвать подарок? Карточка в чате перестанет открываться.',
  'ownGift.revokeConfirmButton': 'Отозвать',
  'ownGift.revoked': 'Подарок отозван — он снова у вас',
  'ownGift.revokeStale': 'Отозвать уже нельзя: подарок открыли или он уже не в чате',
  'ownGift.refund': 'Вернуть деньги',
  'ownGift.refundFooter': 'Деньги вернутся на карту, с которой вы платили, в течение 1–7 дней. Отправить подарок после этого будет нельзя.',
  'ownGift.refundConfirm': 'Вернуть {amount} сум? Деньги придут на карту, с которой вы платили, в течение 1–7 дней. Отправить этот подарок будет уже нельзя.',
  'ownGift.refundConfirmButton': 'Вернуть деньги',
  'ownGift.refunded': 'Возврат оформлен — деньги придут на карту в течение 1–7 дней',
  'ownGift.refundStale': 'Вернуть деньги кнопкой уже нельзя: подарок отправлен в чат или уже возвращён',
  'ownGift.refundAlready': 'Деньги за этот подарок уже возвращены',
  'ownGift.refundRejected': 'Платёжная система не провела возврат. Подарок остался у вас — попробуйте позже или напишите в поддержку.',
  'ownGift.actionOffline': 'Нет соединения. Проверьте интернет и попробуйте ещё раз.',
  'ownGift.actionFailed': 'Не получилось. Попробуйте ещё раз.',
  'ownGift.supportFooter': 'Вернуть деньги за подарок, который уже в чате или у получателя, можно через поддержку.',
  'giftStatus.returned': 'Вернулся к вам',
  'ownGift.returnedAt': 'Вернулся к вам',
  'ownGift.stateDeclined': 'Получатель отказался от подарка, и он снова у вас. Отправьте его другому или верните деньги.',
  'ownGift.stateTimedOut': 'Подарок не приняли за 7 дней, и он вернулся к вам. Отправьте его снова или верните деньги.',
  'ownGift.stateRevoked': 'Вы отозвали подарок — он снова у вас. Отправьте его ещё раз или верните деньги.',
  'ownGift.sendAgain': 'Отправить снова',
} as const

/** Категории числа CLDR — то, что возвращает `Intl.PluralRules#select`. */
export type PluralCategory = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other'

type RuKey = keyof typeof ru

type PluralBase<K> = K extends `${infer Base}.other` ? Base : never

/**
 * Строка с формой числа — основа ключей `<ключ>.one` … `<ключ>.other`
 * (`'locations.points'`); форму выбирает `tn` по `Intl.PluralRules` языка.
 * Признак — ключ `.other` в эталоне.
 */
export type PluralKey = PluralBase<RuKey>

export type PluralFormKey = `${PluralKey}.${PluralCategory}`

/** Обычный ключ: формы числа напрямую не переводятся — только через `tn`. */
export type TranslationKey = Exclude<RuKey, PluralFormKey>

/**
 * Словарь языка: все обычные ключи эталона и у каждой строки с формой числа —
 * формы `Forms`, которые различает язык, плюс `other` (запасная).
 */
export type Dictionary<Forms extends PluralCategory = 'one'> = Record<TranslationKey, string> &
  Record<`${PluralKey}.${Forms | 'other'}`, string> &
  Partial<Record<PluralFormKey, string>>
